import { API_SETMEAL_CATEGORY_ALL } from '@constant'
import http, { createApi } from '@core/fetch'

export default {
  // 获取灰度测试城市
  getGrayCity: createApi('/hms/mainLocalService/appApi/channel/commonSetting'),
  // 获取商家发布信息
  getMercantPublicInfo: createApi(
    '/hms/hljComplaint/adminApi/proof/merchant/info'
  ),
  // 获取标签数据
  getMealMarks: params =>
    http.get('/p/wedding/index.php/admin/APISetMeal/mealMarks', {
      body: params
    }),
  // 获取案例分类
  getCaseCate: params =>
    http.get(API_SETMEAL_CATEGORY_ALL, {
      body: params
    }),
  // 高定标签列表
  getTopWeddingTag: body =>
    http('/hps/admin/figure/topWedding/topLabel', {
      body
    }),
  // 新增案例分类
  addCaseCate: params =>
    http.post('/p/wedding/Admin/APISetMealMerchantCategory/Add', {
      body: params
    }),
  // 编辑案例 || 新增案例
  editCase: params =>
    http.post(`/hms/hljLocalserviceProduct/adminApi/setMeal/editCase`, {
      body: params,
      ignore: [null, undefined]
    }),
  // 保存草稿
  saveDraft: body =>
    http.post('/hms/merchant/appApi/draftCase/edit', {
      body
    }),
  // 获取案例详情
  getCaseDetail: createApi('/p/wedding/index.php/admin/APISetMeal/info'),
  // 获取案例详情
  getCase: createApi('/hms/hljLocalserviceProduct/adminApi/setMeal/info'),
  // 获取草稿详情
  getDraftDetail: body =>
    http('/hms/merchant/appApi/draftCase/detail', {
      body
    }),
  // 案例类目
  getCaseProperties: params =>
    http.get('/p/wedding/Admin/APISetMeal/properties', {
      body: params
    }),
  // 搜索酒店
  getHotels: body =>
    http.get('/p/wedding/index.php/admin/APIHotelMerchant/SearchHotel', {
      body
    }),
  // 删除草稿
  delDraft: body =>
    http.post('/hms/merchant/appApi/draftCase/delete', {
      body,

      onError: false
    }),
  // 删除案例
  deleteSetMeal: params =>
    http.post('/p/wedding/index.php/Admin/APISetMeal/delete', {
      body: params,
      onError: false
    }),
  // 案例名称敏感词检查
  checkWord: body =>
    http.post('/hps/admin/localServerMerchant/index/setMealSensitiveWord', {
      body,
      ignore: []
    }),
  // 发起申诉
  lunchComplaint: createApi.post(
    '/hms/hljComplaint/adminApi/proof/case/appeal'
  ),
  // 获取水镜案例详情（数据结构和婚礼纪平台相同）
  getShuijingCaseWithPlatformlike: createApi(
    '/p/wedding/index.php/Admin/APIGeneralModule/GeneralAlbumDetail'
  ),
  // 将婚礼纪平台案例导入到水镜门店
  importPlatformCaseToShuijing: createApi.post(
    '/p/wedding/index.php/admin/APIGeneralModule/ImportToWaterMirror'
  ),
  // 获取水镜分类级联列表
  getMirrorCategoryCascaderListNew: createApi(
    //eslint-disable-next-line
    '/hms/hljStore/api/generalModule/getAllStructure'
  ),
  // 根据酒店商家获取宴会厅
  getHotelBallroom: createApi(
    '/p/wedding/index.php/admin/APIHotelMerchant/hall_list_merchant'
  ),
  // 获取案例图片分区标签
  getCaseImageTag: createApi(
    '/p/wedding/index.php/Admin/APISetMeal/ImgTypeTags'
  ),
  // 查询该案例是否可以上架
  validateOnline: createApi(
    '/p/wedding/index.php/Admin/APISetMeal/ConsultCaseIsExpired',
    {
      onError: null
    }
  ),
  // 案例数是否大于 8 且 是否含有参考案例数
  getConsultCount: createApi(
    '/p/wedding/index.php/Admin/APISetMeal/ConsultCaseNum'
  )
}
